import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useApi } from '../useApi';
import { workRegisterKeys } from './workRegisters.key';
import { useDebounce } from '../../../features/redListedCompanies/helpers/debounceSearch';

export type SortPersonnel =
  | 'firstName_ASC'
  | 'firstName_DESC'
  | 'lastName_ASC'
  | 'lastName_DESC'
  | 'companyName_ASC'
  | 'companyName_DESC'
  | 'special';

export type FilterPersonnel =
  | 'none'
  | 'NO_EPL'
  | 'ID06_CARD'
  | 'ID_CARD'
  | 'NO_SAFE'
  | 'AT_UT'
  | 'SAFTEY'
  | 'A1_CERTIFICATE'
  | 'INSPECTED'
  | 'NOT_INSPECTED';

export function useGetAllPersonnel(
  controlId: string,
  workRegisterId: string | undefined,
  page: number,
  sort: SortPersonnel = 'firstName_ASC',
  filter: FilterPersonnel = 'none',
  search = ''
) {
  const getApi = useApi();
  const [count, setCount] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const debounce = useDebounce();

  useEffect(() => {
    debounce(() => setDebouncedSearch(search), 300);
  }, [search]);

  const getAllPersonnel = async () => {
    const api = await getApi();
    const take = 20;
    const skip = page * take;

    if (!workRegisterId) return Promise.resolve([]);

    const res = await api.personnelFindAll(
      workRegisterId,
      take,
      skip,
      sort,
      filter,
      debouncedSearch
    );

    setCount(Number(res.headers['x-total-count']));
    return res.data;
  };
  const query = useQuery({
    queryKey: workRegisterKeys.personnelFindMany(
      controlId,
      {
        page,
        sort,
      },
      filter,
      debouncedSearch
    ),
    queryFn: getAllPersonnel,
  });

  return {
    ...query,
    count,
  };
}
